export default __webpack_public_path__ + "static/media/Ballroll_00210.1c0d562d.png";